export const trimMarkdownBlock = (markdown: string) => {
  const trimmed = markdown.trim().replaceAll('```', '')
  const regex = /^\s*m(arkdown)?/
  const match = regex.exec(trimmed)
  if (match) {
    return trimmed.slice(match[0].length).trim()
  }
  return trimmed.trim()
}
